import {combineReducers} from "redux";
import misc from "./misc";

const AppReducer = combineReducers({
  misc,
});


export default AppReducer;
